import axios from 'axios'
import { jwtDecode } from 'jwt-decode'
let apiUrl

if (process.env.NODE_ENV === 'development') {
    apiUrl = `http://localhost:3000`
}
else {
    apiUrl = ``
}

const tokenDecode = (token) => {
    try {
        token = token?.split('.')
        token[1] = token[1]?.slice(5) 
        token = token?.join('.')
        return jwtDecode(token)
    } catch (e) {
        // console.error('Error decoding token:', e)
    }
}

// Axios GET Request Wrapper
const get = (url, params = {}) => {
    return axios.get(url, {
        ...params
    })
        .then((res) => {
            let token = res.data
            const tokenData = tokenDecode(token, url)

            // console.log('tokenData', tokenData)

            // if (tokenData?.isSessionExpied) {
            //     // errorMessage(tokenData?.message)
            //     window.location.href = `${window.location.origin}/login`
            //     return
            // }

            return tokenData
        })
        .catch((e) => e?.response?.data)
}

const post = (url, body = {}, params = {}) => {
    return axios.post(url, body, {
        ...params
    })
        .then((res) => {
            let token = res.data
            const tokenData = tokenDecode(token)

            // if (tokenData?.isSessionExpied) {
            //     // errorMessage(tokenData?.message)
            //     window.location.href = `${window.location.origin}/login`
            //     return
            // }

            return tokenData
        })
        .catch((e) => {
            // console.log('e', e)
            return e?.response?.data
        })
}

const patch = (url, body = {}, params = {}) => {
    return axios.patch(url, body, {
        ...params
    })
        .then((res) => tokenDecode(res.data))
        .catch((e) => e?.response?.data)
}

const secureApi = {
    get,
    post,
    patch
}

export { apiUrl, secureApi ,tokenDecode}